import React from 'react';
import DashboardFullRow from "@web/components/DashboardFullRow";
import CreateApp from "@clients/app-builder/CreateApp";
import {UserContext, WindowContext} from "@web/hooks/context";
import LandingPage from "@web/page/LandingPage";

function ApplicationWorkflowCreate() {
  const [,, height] = React.useContext(WindowContext);
  const [, h, u, claims] = React.useContext(UserContext);

  return <DashboardFullRow>
    <section
      style={{
        width: "100%",
        // backgroundColor: "#0e161f",
        minHeight: height,
      }}
    >
      {claims?.data?.subs?.includes("creator") || claims?.data?.subs?.includes("creator-pro") ?
        <CreateApp /> :
        <LandingPage />}
    </section>
  </DashboardFullRow>
}

export default ApplicationWorkflowCreate;
